import React from "react";

export default function Seite({ titel, children }) {
  return (
    <div style={styles.container}>
      <h2 style={styles.titel}>{titel}</h2>
      {children}
    </div>
  );
}

const styles = {
  container: { padding: "clamp(0.75rem, 2.5vw, 2rem)", width: "100%", boxSizing: "border-box" },
  titel: { marginTop: 0, marginBottom: "1.5rem", color: "#1a3558" },
};
